import React from "react";

import { Link } from "gatsby";
import { LINK_COLOR } from "../../lib/constants";

const Breadcrumbs = ({ text }) => {
  return (
    <div
      style={{
        marginBottom: 20,
      }}
    >
      <Link
        style={{
          color: LINK_COLOR,
          textDecoration: "none",
          backgroundImage: "none",
          cursor: "pointer",
          boxShadow: "none",
        }}
        to="/"
      >
        AvocadoPunks
      </Link>
      <span
        style={{
          color: "#888",
          margin: "0 5px",
        }}
      >
        /
      </span>
      <span
        style={{
          color: "#888",
        }}
      >
        {text}
      </span>
    </div>
  );
};

export default Breadcrumbs;
